"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Decorator = void 0;
/**
 * Supported decorators.
 */
var Decorator;
(function (Decorator) {
    Decorator["Class"] = "Class";
    Decorator["Method"] = "Method";
    Decorator["Property"] = "Property";
    Decorator["Accessor"] = "Accessor";
    Decorator["Parameter"] = "Parameter";
})(Decorator = exports.Decorator || (exports.Decorator = {}));
//# sourceMappingURL=decorator.js.map